<template>
  <q-list
    class="no-hover"
    v-bind="$attrs"
  >
    <slot/>
  </q-list>
</template>

<script>
export default {
  name: 'AppList',
  props: {},
};
</script>

<style lang="scss" scoped>
::v-deep .q-item {
  &__section--avatar {
    min-width: 20px !important;
  }
}
</style>
